// mds-dojo — dojo/_base/kernel — the `dojo` root object. Slim vs the real kernel
// (no loader/AMD bookkeeping — Vite handles modules), but exposes the runtime
// surface widgets read: global, config, doc, isAsync, version, locale, and the
// scope names. `dojo` is also published on the global for legacy lookups.
import config from './config';

const glob: any = globalThis as any;

const dojo: any = glob.dojo || {};

dojo.global = glob;
dojo.config = config;
dojo.doc = glob.document || null;
dojo.isAsync = true; // Vite/ESM loads asynchronously (no sync legacy require path)
dojo.locale = config.locale;
dojo._scopeName = 'dojo';
dojo.baseUrl = './';
dojo.version = { major: 1, minor: 16, patch: 0, flag: 'mds', revision: 0,
  toString(this: any) { return this.major + '.' + this.minor + '.' + this.patch + this.flag; } };

// publish for legacy global lookups (window.dojo)
glob.dojo = dojo;

export default dojo;
